import { apiClient, getAuthToken } from '@/shared/data/client';
import { mapCodeDirectoryDto, mapQueryResult } from '@/shared/data/dtoMappers';
import type { CodeDirectoryDto, QueryFilter, QueryResult } from '@flowqa/shared';

type CodeDirectoryQueryRequest = {
  page: number;
  pageSize: number;
  filters?: QueryFilter[];
  sorts?: Array<{ field: string; direction: 'asc' | 'desc' }>;
};

type UpdateCodeDirectoryTagsInput = {
  id: string;
  tags?: string[];
};

export const queryCodeDirectories = async (
  input: CodeDirectoryQueryRequest,
  orgId?: string | null,
): Promise<QueryResult<CodeDirectoryDto>> => {
  const result = await apiClient.post<QueryResult<CodeDirectoryDto>>(
    'code-directories/query',
    input,
    {
      orgId,
    },
  );
  return mapQueryResult(result, mapCodeDirectoryDto);
};

export const getCodeDirectoryById = async (
  id: string,
  orgId?: string | null,
): Promise<CodeDirectoryDto> =>
  mapCodeDirectoryDto(await apiClient.get<CodeDirectoryDto>(`code-directories/${id}`, { orgId }));

export const updateCodeDirectoryTags = async (
  input: UpdateCodeDirectoryTagsInput,
  orgId?: string | null,
): Promise<CodeDirectoryDto> => {
  const token = getAuthToken();
  return mapCodeDirectoryDto(
    await apiClient.post<CodeDirectoryDto>(
      `code-directories/${input.id}/tags`,
      { tags: input.tags },
      { orgId, token },
    ),
  );
};

export const deleteCodeDirectory = async (
  input: { id: string },
  orgId?: string | null,
): Promise<{ id: string }> => {
  await apiClient.post<undefined>(`code-directories/${input.id}/delete`, undefined, {
    orgId,
    token: getAuthToken(),
  });
  return { id: input.id };
};
